<template>
    <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMainServer
          :datatable="table"
          :on-success="SuccessTableAction"
          :itemsAction="SuccessTableAction"
          :Updatepagination="params"
          :on-pagination="pagePagination"
          :on-search="getSearchPagePagination"
        />
        <ViewDetails :object="object" type="JugadoresDetails" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'

export default {
  mixins: [Permission],
  props: {
    equipo: {
      type: Object,
      required: true
    },
    jugadores: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'jugador.entry' },
          { title: 'Configuracion Jugadores', icon: 'mdi-cog', color: 'success', action: 'maxPlayer', code: '' }
        ],
        titles: [
          { text: 'Nombre del Equipo', value: 'descripcion.equipo_nombre', class: 'black--text' },
          { text: 'activo', value: 'activo', class: 'black--text' }
          // { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          // { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {},
    breadcrumb: [] // Inicializa el breadcrumb
  }),
  components: {
    DataTableMainServer,
    ViewDetails
  },
  mounted () {
    // Obtener el breadcrumb de la ruta
    this.breadcrumb = this.$route.meta.breadcrumb || []

    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true // Muestra el estado de carga
      if (val) this.params = val // Actualiza params si se pasa un valor
      else this.params = this.default // Usa valores por defecto si no
      // Verifica que el espacio esté definido antes de usarlo
      if (!this.equipo) {
        console.error('El ID del espacio no está definido.')
        return // Sale si el ID del espacio no está disponible
      }
      // Asigna el espacioId usando el valor recibido como prop
      this.params.EquipoId = this.equipo
      // Ejecuta la URL para obtener la paginación
      this.ExecuteUrl('jugadores.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('jugadores.list-pagination')
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    showDialogFechas (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'tickets',
        with: '60%',
        title: 'Reporte General',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_ReporteGeneralInventariablesForm,
            message: 'Registro Agregado Correctamente',
            paramsForm: { hiddenBtnSuccess: true, nameBtnSuccess: 'Descargar PDF' }
          }
        }
      })
    },

    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosjugadoresFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    // tojugadores (item) {
    //   this.$router.push({ name: 'jugadoresTableView', params: { jugadoresId: item.item.id } })
    // },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('jugadores.list-pagination')
    },
    newData (item) {
      console.log('¿Se alcanzó el límite de equipos?', this.maxTeamReached) // Revisa si maxTeamReached está funcionando correctamente
      if (this.maxTeamReached) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'Se Alcanzo el Limite De Jugadores.'
        })
        return
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Agregar Jugador',
        body: {
          objectMain: { tipo_actividad_id: 5, empresa_id: this.user.empresa_id, equipo_id: this.equipo.id },
          paramsDialog: {
            url: this.get_urls['jugadores.execute'],
            urloption: this.get_urls['jugadores.options'],
            process: 1,
            actividad: 5,
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    maxPlayer (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Maximo de Jugadores',
        body: {
          objectMain: { equipo_id: this.equipo.id },
          paramsDialog: {
            form: this.get_PlayersForm,
            url: this.get_urls['jugadores.maxplayer'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    }
    // toUpdate (item) {
    //   const data = {
    //     id: item.item.id,
    //     descripcion: item.item.caracteristicas.descripcion,
    //     proveedor: item.item.caracteristicas.proveedor,
    //     proveedor_id: item.item.caracteristicas.proveedor_id,
    //     marca_id: item.item.caracteristicas.marca_id,
    //     Alta: item.item.caracteristicas.Alta,
    //     Compra: item.item.caracteristicas.Compra,
    //     comentarios: item.item.caracteristicas.comentarios,
    //     procedencia_id: item.item.caracteristicas.procedencia_id,
    //     tipo_solicitud: item.item.caracteristicas.tipo_solicitud,
    //     PrecioU: item.item.caracteristicas.PrecioU,
    //     facturas: item.item.factura,
    //     factura_id: item.item.caracteristicas.factura_id,
    //     partida_ids: item.item.caracteristicas.partida_ids || [],
    //     departamento_id: item.item.departamento_id,
    //     departamento: item.item.departamento
    //   }
    //   this.SHOW_DIALOG_MAIN({
    //     type: 'update',
    //     form: 'process',
    //     with: '60%',
    //     title: 'Editar Bien',
    //     body: {
    //       objectMain: data,
    //       paramsDialog: {
    //         urloption: this.get_urls['jugadores.options'],
    //         url: this.get_urls['jugadores.execute'],
    //         process: 1,
    //         actividad: item.item.tipo_inventario_id,
    //         message: 'Registro Actualizado Correctamente',
    //         showFamilia: true,
    //         familiaParams: '?insumo=2,0',
    //         familiaSelected: item.item.caracteristicas.familia_id,
    //         setmodel: true,
    //         updated: true,
    //         data: (item.item.especificaciones) ? item.item.especificaciones : {}
    //       }
    //     }
    //   })
    // }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_objects', 'get_PlayersForm', 'get_InventariosjugadoresFilterForm', 'get_TicketsUuAaForm', 'get_ReporteGeneralInventariablesForm']),
    object () {
      return this.table.modelMain.length > 0 ? this.table.modelMain[0] : {}
    },
    maxTeamReached () {
      const maxPlayers = this.equipo && this.equipo.nombre && this.equipo.nombre.maxplayer
        ? this.equipo.nombre.maxplayer
        : null
      console.log('MaxPlayers:', maxPlayers)

      // Verifica si `NumJugadores` está disponible en el primer elemento de `data`
      const numJugadores = this.table.body.data.length > 0 && this.table.body.data[0].NumJugadores
        ? this.table.body.data[0].NumJugadores
        : 0

      console.log('Current equipos length:', numJugadores)

      // Aplica la regla solo si maxPlayers tiene un valor, de lo contrario permite el paso
      return maxPlayers !== null ? numJugadores >= maxPlayers : false
    }

  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  }
}
</script>

<style scoped>
/* Aquí puedes agregar estilos específicos para tu componente */
</style>
